'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobSiteCore', cobSiteCore);

	cobSiteCore.$inject = [
		'subjectObserverMessagesService',
		'$window'
	];

	var subjectObserverMessagesService,
		subjectMessages,
		observerMessages,
		$window;

	function cobSiteCore(_subjectObserverMessagesService_, _$window_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		$window = _$window_;

		return {
			scope: {},
			templateUrl: '/app/common/welcome/siteCore.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.openLiveChat = openLiveChat;
		}


		function openLiveChat() {
			var niceInContactBaseUrl = 'https://home-c37.nice-incontact.com/inContact/ChatClient/ChatClient.aspx?poc={0}&bu={1}&P1={2}&P2={3}; {4}&P3={5}&P4={6}';
			var pointOfContact = '0893c22c-11b6-4b47-943f-649d809655d7';
			var businessUnit = '4599687';
			var niceInContactChatClient = niceInContactBaseUrl
				.replace('{0}', pointOfContact)
				.replace('{1}', businessUnit)
				.replace('{2}', 'DAT OnBoard Guest')
				.replace('{3}', 'guest-user')
				.replace('{4}', 'DOBGuest@dat.com')
				.replace('{5}', '')
				.replace('{6}', $window.location.href);

			var baseWindowOptions = 'location=no, menubar=no, status=no, resizable=no, height={0}, width={1}, top={2}, left={3}';
			var width = 410;
			var height = 700;

			var top = $window.outerHeight / 2 + $window.screenY - (height / 2);
			var left = $window.outerWidth / 2 + $window.screenX - (width / 2);

			var windowOptions = baseWindowOptions
				.replace('{0}', height)
				.replace('{1}', width)
				.replace('{2}', top)
				.replace('{3}', left);

			$window.open(niceInContactChatClient, 'niceInContactChat', windowOptions);
		}
	}
})();
